module.exports = __webpack_public_path__ + "img/andreea_pose_01.a027e702.png";